module.exports = __webpack_public_path__ + "img/dollarello.9509c1ea.gif";